import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { TeiasoftLoaderService } from '../../services/teiasoft-bucket/teiasoft-loader.service';
import { BackendService } from '../../services/backend/backend.service';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../globals/globals';
import { OpenItdcrEvent } from '../../models/app/openItdcr.model';
import { finalize } from 'rxjs/operators';
import { TeiasoftToasterService } from '../../services/teiasoft-bucket/teiasoft-toaster.service';

export class FeasibilityByExperienceDetails {
  comments?: string;
  timestamp?: number;
  username?: string;
}

export class FeasibilityDetail {
  feasibilityByExperienceDetails?: FeasibilityByExperienceDetails;
  feasibilityByItrDetails?: {
    description?: string;
  };
  feasibilityByStandardBookDetails?: any;
  feasibilitySource?: string;
}

@Component({
  selector: 'app-modal-feasibility-options',
  templateUrl: './modal-feasibility-options.component.html',
  styleUrls: ['./modal-feasibility-options.component.scss']
})
export class ModalFeasibilityOptionsComponent implements OnInit, OnChanges {

  @Input() enquiryNo: string = "";
  @Input() itemNo: string = "";
  @Input() feasibilityStatus: string = "";
  @Input() isMobile: boolean = false;
  @Input() theme: string = "silver";
  @Input() dataSet: any[] = new Array();
  @Input() readOnly: boolean = true;


  @Output() onCancel: EventEmitter<any[]> = new EventEmitter();
  @Output() onOpenITDCR: EventEmitter<OpenItdcrEvent> = new EventEmitter();



  action: string = "";
  comments: string = "";
  title: string = "";
  feasibilityDetail: FeasibilityDetail = new FeasibilityDetail();
  showItdcrViewerModal: boolean = false;
  selectedItdcrNo: string = '';
  constructor(private teiasoftLoader: TeiasoftLoaderService, private beService: BackendService, private translate: TranslateService,
    public globals: Globals, private teiasoftToaster: TeiasoftToasterService) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["feasibilityStatus"]) {
      this.feasibilityStatus = changes["feasibilityStatus"].currentValue;
      if (this.feasibilityStatus == 'ToBeEvaluated') this.title = this.translate.instant("feasibility.title1");
      if (this.feasibilityStatus != 'ToBeEvaluated') {
        this.getFeasibilityDetails();
      }
    }

    if (changes && changes["enquiryNo"]) {
      this.enquiryNo = changes["enquiryNo"].currentValue;
    }

    if (changes && changes["dataSet"]) {
      this.dataSet = changes["dataSet"].currentValue;
    }

    if (changes && changes["itemNo"]) {
      this.itemNo = changes["itemNo"].currentValue;
    }
  }

  /* METHODS */
  declareItemAsFeasbible() {
    this.teiasoftLoader.start();
    this.beService.setItemFeasibleByExperience(this.enquiryNo, this.itemNo, this.comments).subscribe(res => {
      this.teiasoftLoader.stop();
      let _i: number = this.dataSet.findIndex(x => x["itemNo"] == this.itemNo);
      if (_i != -1) {
        this.dataSet[_i]["feasibilityStatus"] = 'Validated';
      }
      this.onCancel.emit(this.dataSet);
    });
  }

  getFeasibilityDetails() {
    this.teiasoftLoader.start();
    this.beService.getItemFeasibilityDetails(this.enquiryNo, this.itemNo).subscribe(res => {
      this.teiasoftLoader.stop();
      this.feasibilityDetail = new FeasibilityDetail();
      this.feasibilityDetail = res;
      if (res.feasibilitySource == "Experience") {
        this.title = this.translate.instant("feasibility.byExperience");
      }
      if (res.feasibilitySource == "Itr") {
        this.title = this.translate.instant("feasibility.byItr");
      }
    });
  }

  onCancelClick() {
    this.action = "";
    this.onCancel.emit([]);
  }

  onSearchByExpClick() {
    this.action = "searchByExp";
  }

  onDeclareItemFeasbile() {
    this.declareItemAsFeasbible();
  }

  onInputChange(evt: any) {
    this.comments = evt.target.value;
  }

  onOpenITDCRClick() {
    this.onOpenITDCR.emit(
      {
        enquiryNo: this.enquiryNo,
        itemNo: this.itemNo!,
        sourceEvent: 'F'
      });
  }

  get showItdcrHistoryLink(): boolean {
    const source = String(this.feasibilityDetail?.feasibilitySource ?? '').trim().toLowerCase();
    return source === 'itdcr' || source === 'itr';
  }

  onNavigateToItdcrHistory() {
    if (!this.enquiryNo || !this.itemNo || !this.showItdcrHistoryLink) return;

    this.teiasoftLoader.start();
    this.beService.getItdcrNumberByItemAndCategory(this.enquiryNo, this.itemNo, 'F')
      .pipe(finalize(() => this.teiasoftLoader.stop()))
      .subscribe(res => {
        const itdcrNo = res?.itdcrNo?.trim?.() || '';
        if (!itdcrNo) {
          this.teiasoftToaster.show("info", this.translate.instant("itdcr.notAvailableForItem"));
          return;
        }

        this.selectedItdcrNo = itdcrNo;
        this.showItdcrViewerModal = true;
      });
  }

  onCloseItdcrViewer() {
    this.showItdcrViewerModal = false;
    this.selectedItdcrNo = '';
  }
}
